import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
} from '@mui/material';
import { colors, fonts, spacing, borderRadius, shadows, tableStyles } from '../../constants';
import { ROWS_PER_PAGE_OPTIONS } from '../../constants/slaDashboard';
import SLATableRow from './SLATableRow';

/**
 * SLATable Component
 * Main table component with header, body, and pagination
 */
const SLATable = ({
  queries,
  loading,
  page,
  rowsPerPage,
  total,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <Paper sx={{ borderRadius: borderRadius.md, boxShadow: shadows.md, width: '100%', mb: spacing.sm }}>
      <Box sx={{ p: spacing.xs, borderBottom: `1px solid ${colors.borderDefault}` }}>
        <Typography variant="h6" sx={{ fontWeight: fonts.weightBold, fontSize: fonts.fontSizeMd }}>
          Queries with SLA Status
        </Typography>
      </Box>
      <TableContainer sx={{ width: '100%' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: colors.backgroundSoft }}>
              <TableCell sx={tableStyles.header}>Query ID</TableCell>
              <TableCell sx={tableStyles.header}>Priority</TableCell>
              <TableCell sx={tableStyles.header}>Project</TableCell>
              <TableCell sx={tableStyles.header}>SLA Status</TableCell>
              <TableCell sx={tableStyles.header}>SLA Due</TableCell>
              <TableCell sx={tableStyles.header}>Time Remaining</TableCell>
              <TableCell sx={tableStyles.header}>Response Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} sx={{ ...tableStyles.cell, textAlign: 'center', py: spacing.xl }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : queries.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} sx={{ ...tableStyles.cell, textAlign: 'center', py: spacing.xl }}>
                  <Typography variant="body2" sx={{ color: colors.textSecondary }}>
                    No queries with SLA found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              queries.map((query) => (
                <SLATableRow key={query.id} query={query} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        sx={{
          borderTop: `1px solid ${colors.borderDefault}`,
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
            fontSize: fonts.fontSizeXs,
            color: colors.textSecondary,
          },
          '& .MuiIconButton-root': {
            color: colors.textSecondary,
            '&:hover': {
              backgroundColor: colors.backgroundSoft,
            },
          },
        }}
      />
    </Paper>
  );
};

export default SLATable;
